import apiCore from '../../utils/api-core';

export function getAuthURL() {
	return apiCore.get('/api/v1/mailchimp/auth-uri');
}

export function getAccessToken(code) {
	return apiCore.get(`/api/v1/mailchimp/request-token/${code}`);
}

export function getLists(data) {
    return apiCore.post('/api/v1/mailchimp/get-lists', data);
}

export function saveMailChimpData(data) {
    return apiCore.post('/api/v1/mailchimp', data);
}